import SolovitPremissions from './solovitPremissons.enum';
import AreaContainerPremission from './areaContainerPremission.enum';
import ClientPremission from './ClientPremission.enum';
import EasyStorePremission from './easyStorePremission.enum';
import EmployeePremission from './employeePremission.enum';
import GroupItemPremission from './groupItems.enum';
import ItemsPremission from './ItemsPremissons.enum';
import JobPremission from './jobPremission.enum';
import MasterPremission from './MasterPremissions.enum';
import RequestPurchasesPremission from './RequestPurchasesPremission.enum';
import SalesInvoicePremission from './SalesInvoicePremission.enum';
import SupplierPremission from './Supplier.enum';
import TargetTeleSalesPermission from './TargetTeleSalesPermission.enum';
import AreaTargetPermission from './AreaTargetPermission.enum';
import AppVersionPermission from './AppVersionPermission.enum';
import InventoryPermission from './InventoryPermission.enum';
import QuotaControlPermission from './QuotaControlPermission.enum';
import GeneralSettingPermission from './GeneralSettingPermission.enum';
import ClientLocationPermission from './ClientLocationPermission.enum';
import CashCollectionPermission from './CashCollectionPermission.enum';
import NotificationPermission from './NotificationPermission.enum';
import MonitoringPermission from './MonitoringPermission.enum';
import BounsInvoicePermission from './BounsInvoicePermission.enum';

type Premission =
  | JobPremission
  | EmployeePremission
  | EasyStorePremission
  | AreaContainerPremission
  | GroupItemPremission
  | SupplierPremission
  | RequestPurchasesPremission
  | MasterPremission
  | SalesInvoicePremission
  | ItemsPremission
  | ClientPremission
  | SolovitPremissions
  | TargetTeleSalesPermission
  | AreaTargetPermission
  | AppVersionPermission
  | InventoryPermission
  | QuotaControlPermission
  | GeneralSettingPermission
  | ClientLocationPermission
  | CashCollectionPermission
  | NotificationPermission
  | MonitoringPermission
  | BounsInvoicePermission;

const Premission = {
  ...JobPremission,
  ...EmployeePremission,
  ...EasyStorePremission,
  ...AreaContainerPremission,
  ...ClientPremission,
  ...GroupItemPremission,
  ...SupplierPremission,
  ...RequestPurchasesPremission,
  ...MasterPremission,
  ...SalesInvoicePremission,
  ...ItemsPremission,
  ...SolovitPremissions,
  ...TargetTeleSalesPermission,
  ...AppVersionPermission,
  ...AreaTargetPermission,
  ...InventoryPermission,
  ...QuotaControlPermission,
  ...GeneralSettingPermission,
  ...ClientLocationPermission,
  ...CashCollectionPermission,
  ...NotificationPermission,
  ...MonitoringPermission,
  ...BounsInvoicePermission,
} as const;

export type { Premission };
export default Premission;
